// extracted by mini-css-extract-plugin
export var askAiIcon = "_p3-9";
export var container = "_p3-0";
export var groupSeparator = "_p3-a";
export var highlight = "_p3-4";
export var resultIcon = "_p3-5";
export var resultItem = "_p3-7";
export var resultSubtitle = "_p3-3";
export var resultTitle = "_p3-2";
export var resultsList = "_p3-1";
export var searchGroup = "_p3-6";
export var selected = "_p3-8";